import React, { useState } from 'react'
import PreviewPopupTable from './PreviewPopupTable';
import CommonLayout from '../CommonLayout';


const EditTypeAction = ({prevData,newData}) => {
  const [showPopup,setShowPopup] = useState(false);
  const [types, setTypesData] = useState({})

  const fieldsData = [
      {colKey:"name", colText:"Name"},
      {colKey:"orders", colText:"Order"},
      {colKey:"short_description", colText:"Short Description"},
      {colKey:"is_module_show", colText:"Module"},
      {colKey:"is_procedure_show", colText:"Document"},
      {colKey:"is_flowchart_show", colText:"Document and Flowchart"},
      {colKey:"is_allow_record_show", colText:"Document with Records"},
      {colKey:"is_record_show", colText:"Record"},
      {colKey:"is_none_show", colText:"None"},
  ]

  function keysModifier(obj){
    if(obj.is_module) obj.is_module_show = "Yes"
    else obj.is_module_show = "No"

    if(obj.is_procedure) obj.is_procedure_show = "Yes"
    else obj.is_procedure_show = "No"

    if(obj.is_flowchart) obj.is_flowchart_show = "Yes"
    else obj.is_flowchart_show = "No"

    if(obj.is_allow_record) obj.is_allow_record_show = "Yes"
    else obj.is_allow_record_show = "No"

    if(obj.is_record) obj.is_record_show = "Yes"
    else obj.is_record_show = "No"

    if(obj.is_none) obj.is_none_show = "Yes"
    else obj.is_none_show = "No"
  }

  keysModifier(prevData)
  keysModifier(newData)
  

  
  const showPopupHanldel = (data) =>{
    setTypesData(data)
    setShowPopup(true)
  }
      
  return <>
    <CommonLayout
        prevData={prevData}
        newData={newData}
        fieldsData={fieldsData}
        showPopupHanldel={showPopupHanldel}
    />  
    {showPopup && <PreviewPopupTable type={types} hidePopup={()=>setShowPopup(false)}/>}
  </>;
}

export default EditTypeAction